module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/admin-page/admin-page.component.html
// module id = ./src/app/admin/components/admin-page/admin-page.component.html
// module chunks = main